var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "soli-round", class: { white: !_vm.dark } }, [
    _c(
      "div",
      {
        staticClass: "mb-3 soli-grey text-align-start font-weight-bold text-h3",
        class: { "white--text": _vm.dark },
      },
      [_vm._t("default")],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "px-1 soli-grey text-align-start text-lg",
        class: { "white--text": _vm.dark },
      },
      [_vm._t("subtitle")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }